import React from 'react';
import moment from 'moment/moment';
import styles from '../../../../../../styles/YearSlide.module.css';
import quotesStyle from '../../../../../../styles/quotes.module.css';
import useWidth from '../../../../../../util/hooks/useWidth';
import Checkbox from '../../../../../mainEvent/components/Checkbox';
import { createBreakpoint, useWindowSize } from 'react-use';
const ChevronLeft = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M15 18l-6-6 6-6"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const ChevronRight = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M9 18l6-6-6-6"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const SelectDateYearSlide = ({
    selectedMonth,
    selectedYear,
    handleMonthSelect,
    handleYearSelect,
}) => {
  const {width} = useWindowSize();

    const handleYearChange = (selectedOption) => {
        handleYearSelect(selectedOption.value);
    };

    const handleMonthChange = (selectedOption, value) => {
        handleMonthSelect(value);
    };

    const currentYear = moment().year();
    const currentMonth = moment().month();

    const yearOptions = [];
    for (let year = currentYear; year <= currentYear + 2; year++) {
        yearOptions.push({ value: year, label: year });
    }

    const monthOptions = () => {
        let monthOptions = [];
        for (let month = 0; month < 12; month++) {
            const monthLabel = moment.months()[month];
            const monthValue = month + 1;
            const isDisabled = selectedYear === currentYear && month < currentMonth;
            monthOptions.push({ value: monthValue, label: monthLabel, disabled: isDisabled });
        }
        return monthOptions;
    };

    const handlePrevYear = () => {
        if (selectedYear !== currentYear) {
            handleYearSelect(selectedYear - 1);
        }
    };

    const handleNextYear = () => {
        handleYearSelect(selectedYear + 1);
    };

    return (
        <div className={styles.container}>
<div className={styles.yearSelectContainer}>
    <button
        type="button"
        className={styles.button}
        disabled={selectedYear === currentYear}
        onClick={handlePrevYear}
        aria-label="Previous year"
    >
        <ChevronLeft />
    </button>
    <span>
        {selectedYear}
    </span>
    
   
    <button
        type="button"
        className={styles.button}
        disabled={selectedYear >= currentYear + 2}
        onClick={handleNextYear}
        aria-label="Next year"
    >
        <ChevronRight />
    </button>
</div>
            <div
                className={`${
                    width > 768
                        ? quotesStyle['plan-visit-date-layout']
                        : quotesStyle['plan-visit-checkbox-layout']
                }`}
            >
                {monthOptions().length > 0 &&
                    monthOptions().map((item, index) => (
                        <div className={quotesStyle['plan-visit-layout']} key={index}>
                            <Checkbox
                                key={index}
                                icon={'vm-radio-black'}
                                selectedIcon={'vm-radio-black-active'}
                                label={item.label}
                                value={item.value}
                                isSelected={selectedMonth === item.value}
                                handleChange={handleMonthChange}
                                disabled={item.disabled}
                            />
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default SelectDateYearSlide;
